import { render, staticRenderFns } from "./selectPosts.vue?vue&type=template&id=51d4e5f2&scoped=true"
import script from "./selectPosts.vue?vue&type=script&lang=js"
export * from "./selectPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4e5f2",
  null
  
)

export default component.exports